import { forwardRef } from 'react';
import type { DropdownRef } from '@cbhq/cds-web/dropdown';
import { Dropdown } from '@cbhq/cds-web/dropdown';
import { PopoverContentPositionConfig } from '@cbhq/cds-web/overlays';

const contentPosition = {
  placement: 'bottom-end',
  gap: 1,
} as PopoverContentPositionConfig;

type NavigationDropdownProps = {
  content: React.ReactNode;
  value?: string | undefined;
  children: React.ReactNode;
  testID: string;
  onChange?: (value: string) => void;
  onOpenMenu?: () => void;
  onCloseMenu?: () => void;
};

export const NavigationDropdown = forwardRef<DropdownRef, NavigationDropdownProps>(
  function NavigationDropdown(
    { content, value, children, testID, onChange, onOpenMenu, onCloseMenu },
    ref,
  ) {
    return (
      <Dropdown
        ref={ref}
        content={content}
        value={value}
        testID={testID}
        enableMobileModal
        contentPosition={contentPosition}
        maxHeight={800}
        showOverlay
        onChange={onChange}
        onOpenMenu={onOpenMenu}
        onCloseMenu={onCloseMenu}
      >
        {children}
      </Dropdown>
    );
  },
);
